import { Component, OnInit } from '@angular/core';
import { BeautybookService } from '@features/beautybook/services/beautybook.service';
import { Product } from '@features/product/interfaces/product.interface';
import { ProductService } from '@features/product/services/product.service';
import { LayoutService } from 'src/app/layout/services/layout.service';

import {
  faChevronRight,
  faComment,
  faHeart,
  faShare,
} from '@fortawesome/free-solid-svg-icons';
import { combineLatest, map, mergeMap, Subject, takeUntil } from 'rxjs';
import { DataListParameter } from '@shared/interfaces/data-list-parameter.interface';

@Component({
  selector: 'fc-beautybook-list',
  templateUrl: './beautybook-list.component.html',
  styleUrls: ['./beautybook-list.component.css'],
})
export class BeautybookListComponent implements OnInit {
  private readonly destroy$ = new Subject<void>();

  faChevronRight = faChevronRight;
  faHeart = faHeart;
  faComment = faComment;
  faShare = faShare;

  loading = true;

  beautybookPosts: any = [];

  constructor(
    private productService: ProductService,
    private beautybookService: BeautybookService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.layoutService.isMobile$
      .pipe(
        map((isMobile: boolean) => {
          return isMobile;
        }),
        mergeMap((isMobile: boolean) => {
          const bestSellerProducts = this.productService.getBestSellerProducts(
            5,
            1
          );

          const beautybookPostParam: DataListParameter = {
            item_per_page: 12,
            current_page: 1,
            sorts: [{ field: 'id', direction: 'desc' }],
          };
          const beautybookPosts =
            this.beautybookService.getBeautybookPosts(beautybookPostParam);

          return combineLatest([beautybookPosts]);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(([beautybookPosts]) => {
        this.beautybookPosts = beautybookPosts;
        this.loading = false;
      });
  }
}
